$(document).ready(function(){
  $('.wa-auswahlhilfe-montagesysteme').click(function() {
      $('.wa-auswahlhilfe-montagesysteme-popup-container').addClass('wa-auswahlhilfe-montagesysteme-popup-container-active');
    });
});
$(document).ready(function(){
  $('.close-button-montagesysteme').click(function() {
      $('.wa-auswahlhilfe-montagesysteme-popup-container').removeClass('wa-auswahlhilfe-montagesysteme-popup-container-active');
    });
});


$(document).ready(function(){
  $('.wa-auswahlhilfe-auswahlhilfe').click(function() {
      $('.wa-auswahlhilfe-anschlusskabel-popup-container').addClass('wa-auswahlhilfe-anschlusskabel-popup-container-active');
      $('body').addClass('wwwwwww');
    });
});
$(document).ready(function(){
  $('.close-button-anschlusskabel').click(function() {
      $('.wa-auswahlhilfe-anschlusskabel-popup-container').removeClass('wa-auswahlhilfe-anschlusskabel-popup-container-active');
    });
});